import { Injectable, signal, computed } from '@angular/core';
import { User } from '../models';

@Injectable({
  providedIn: 'root'
})
export class AuthStore {
  private _user = signal<User | null>(null);
  private _isAuthenticated = signal<boolean>(false);
  private _isLoading = signal<boolean>(true); // Start with loading true for initial auth check
  private _error = signal<string | null>(null);

  // Public readonly signals
  readonly user = this._user.asReadonly();
  readonly isAuthenticated = this._isAuthenticated.asReadonly();
  readonly isLoading = this._isLoading.asReadonly();
  readonly error = this._error.asReadonly();

  // Computed signals
  readonly isAdmin = computed(() => {
    const user = this._user();
    return user?.role === 'Admin';
  });

  readonly userDisplayName = computed(() => {
    const user = this._user();
    return user?.name || 'Guest';
  });

  readonly isAuthInitialized = computed(() => {
    return !this._isLoading();
  });

  // Actions
  setUser(user: User | null) {
    this._user.set(user);
    this._isAuthenticated.set(!!user);
    this._error.set(null);
  }

  setLoading(loading: boolean) {
    this._isLoading.set(loading);
  }

  setError(error: string | null) {
    this._error.set(error);
  }

  clearError() {
    this._error.set(null);
  }

  logout() {
    this._user.set(null);
    this._isAuthenticated.set(false);
    this._error.set(null);
  }
}